import React from "react";
import ContentLoader from "react-content-loader";
import { Container } from "./styles";
import {
  FiPlus,
  FiSearch,
  FiCalendar,
  FiTrash2,
} from "react-icons/fi";
import {
  GoShield,
} from "react-icons/go";
import {
  HiOutlineCheckCircle,
  HiOutlineExclamationCircle,
  HiOutlineXCircle,
} from "react-icons/hi";

const CertificatesLoadingSkeleton = ({ isDark = true }) => {
  const backgroundColor = isDark ? "#1a1a1a" : "#f0f0f0";
  const foregroundColor = isDark ? "#2a2a2a" : "#e5e7eb";

  const kpiIcons = [
    { Icon: GoShield, cls: "" },
    { Icon: HiOutlineCheckCircle, cls: "success" },
    { Icon: HiOutlineExclamationCircle, cls: "warning" },
    { Icon: HiOutlineXCircle, cls: "danger" },
  ];

  return (
    <Container>
      {/* HEADER */}
      <div className="header-info">
        <div className="header-details">
          <h3>Certificados Digitais</h3>
          <div className="header-meta">
            <span className="status-tag">SISTEMA ATIVO</span>
            <span className="update-tag">carregando certificados</span>
          </div>
        </div>
      </div>

      {/* KPI CARDS */}
      <div className="kpi-cards">
        {kpiIcons.map((item, i) => {
          const { Icon, cls } = item;
          return (
            <div key={`kpi-${i}`} className={`kpi-card ${cls}`}>
              <div className="card-content">
                <div className="thumb"><Icon /></div>
                <div className="text">
                  <ContentLoader
                    speed={2}
                    width={48}
                    height={28}
                    backgroundColor={backgroundColor}
                    foregroundColor={foregroundColor}
                  >
                    <rect x="0" y="0" rx="4" ry="4" width="48" height="28" />
                  </ContentLoader>
                  <ContentLoader
                    speed={2}
                    width={120}
                    height={10}
                    backgroundColor={backgroundColor}
                    foregroundColor={foregroundColor}
                    style={{ marginTop: 4 }}
                  >
                    <rect x="0" y="0" rx="3" ry="3" width="120" height="10" />
                  </ContentLoader>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* TOOLBAR */}
      <div className="toolbar">
        <div className="toolbar-left">
          <button className="btn-new" style={{ opacity: 0.6 }}>
            <FiPlus />
            Novo Certificado
          </button>
          <div className="search-box">
            <FiSearch />
            <ContentLoader
              speed={2}
              width={200}
              height={14}
              backgroundColor={backgroundColor}
              foregroundColor={foregroundColor}
            >
              <rect x="0" y="0" rx="3" ry="3" width="200" height="14" />
            </ContentLoader>
          </div>
        </div>
        <div className="toolbar-right">
          <button className="filter-pill active">Todos</button>
          <button className="filter-pill">Válidos</button>
          <button className="filter-pill">Expirando</button>
          <button className="filter-pill">Expirados</button>
        </div>
      </div>

      {/* MAIN */}
      <div className="main-content">
        <div className="cert-grid">
          {[...Array(8)].map((_, i) => (
            <div key={`cert-${i}`} className="cert-card ok">
              <div className="cert-actions">
                <button className="btn-delete" style={{ opacity: 0.2, cursor: 'default' }}>
                  <FiTrash2 />
                </button>
              </div>

              <div className="cert-top">
                <span className="cert-eyebrow">CNPJ · ··.···.···/····-··</span>
                <ContentLoader
                  speed={2}
                  width={180}
                  height={18}
                  backgroundColor={backgroundColor}
                  foregroundColor={foregroundColor}
                >
                  <rect x="0" y="0" rx="3" ry="3" width="180" height="14" />
                </ContentLoader>
                <ContentLoader
                  speed={2}
                  width={140}
                  height={10}
                  backgroundColor={backgroundColor}
                  foregroundColor={foregroundColor}
                  style={{ marginTop: 4 }}
                >
                  <rect x="0" y="0" rx="3" ry="3" width="140" height="10" />
                </ContentLoader>
              </div>

              <div className="cert-footer">
                <div className="cert-validity">
                  <FiCalendar />
                  <ContentLoader
                    speed={2}
                    width={80}
                    height={10}
                    backgroundColor={backgroundColor}
                    foregroundColor={foregroundColor}
                  >
                    <rect x="0" y="0" rx="3" ry="3" width="80" height="10" />
                  </ContentLoader>
                </div>
                <ContentLoader
                  speed={2}
                  width={64}
                  height={18}
                  backgroundColor={backgroundColor}
                  foregroundColor={foregroundColor}
                >
                  <rect x="0" y="0" rx="9" ry="9" width="64" height="18" />
                </ContentLoader>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Container>
  );
};

export default CertificatesLoadingSkeleton;
